import * as React from 'react';
const SvgCloud = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.353 7.897a4.72 4.72 0 0 1 9.294 0h.07a3.282 3.282 0 1 1 0 6.564H5.283a3.282 3.282 0 1 1 0-6.564zM10 5.231a3.487 3.487 0 0 0-3.483 3.312.615.615 0 0 1-.615.585h-.62a2.051 2.051 0 0 0 0 4.103h9.436a2.051 2.051 0 0 0 0-4.103h-.62a.615.615 0 0 1-.615-.585A3.487 3.487 0 0 0 10 5.231"
    />
  </svg>
);
export default SvgCloud;
